import without from 'lodash/without';
import reject from 'lodash/reject';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import { connect } from 'react-redux';

const enhance = (barbersViewedSelector, barbersSelector, { add, remove, showAll, hideAll }) => compose(
  connect((state, ownProps) => {
    let barbers = barbersSelector(state);
    let barbersViewed = barbersViewedSelector(state);

    if (ownProps.showUnassigned === false) {
      barbers = reject(barbers, { id: 'unassigned' });
      barbersViewed = without(barbersViewed, 'unassigned');
    }

    return { barbers, barbersViewed };
  }, {
    add,
    remove,
    showAll,
    hideAll,
  }),
  withHandlers({
    updateBarbersViewed: ({ add, remove, showAll, hideAll, barbers }) => (checked, barber = null) => {
      const isBarberChecked = checked && barber;
      const isBarberUnchecked = !checked && barber;
      const isAllChecked = checked && !barber;

      if (isBarberChecked) {
        return add(barber);
      }

      if (isBarberUnchecked) {
        return remove(barber);
      }

      if (isAllChecked) {
        return showAll(barbers);
      }

      return hideAll();
    },
  })
);

export default enhance;
